import { createActions, createReducer } from 'reduxsauce'

const situacoesPagamentos = [
    { value: '', label: 'Todas' },
    { value: 'S', label: 'Pagos' },
    { value: 'N', label: 'Não Pagos' },
]

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoConsultaDiarias: ['administracao'],
    removeNomeConsultaDiarias: ['nome'],
    removeCpfConsultaDiarias: ['cpf'],
    removeDataEmpenhoInicialConsultaDiarias: ['dataEmpenhoInicial'],
    removeDataEmpenhoFinalConsultaDiarias: ['dataEmpenhoFinal'],
    removeCargoConsultaDiarias: ['cargo'],
    removeSituacaoPagamentoConsultaDiarias: ['situacaoPagamento'],
    setMostraAplicarFiltroConsultaDiarias: [],
    limpaFiltroConsultaDiarias: [],
    aplicarFiltroConsultaDiarias: ['filtro'],
})

const INITIAL_STATE = {
    administracao: [],
    nome: '',
    cpf: '',
    dataEmpenhoInicial: '',
    dataEmpenhoFinal: '',
    cargo: [],
    situacaoPagamento: { value: situacoesPagamentos[0].value, label: situacoesPagamentos[0].label },
    mostraAplicarFiltro: false,
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeNome = (state = INITIAL_STATE, action) => {
    return { ...state, nome: '', mostraAplicarFiltro: true }
}

const removeCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: '', mostraAplicarFiltro: true }
}

const removeDataEmpenhoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataEmpenhoInicial: '', mostraAplicarFiltro: true }
}

const removeDataEmpenhoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataEmpenhoFinal: '', mostraAplicarFiltro: true }
}

const removeCargo = (state = INITIAL_STATE, action) => {
    state.cargo.splice(state.cargo.indexOf(action.cargo), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.cargo = Array.from(state.cargo)
    return { ...state, mostraAplicarFiltro: true }
}

const removeSituacaoPagamento = (state = INITIAL_STATE, action) => {
    return { ...state, situacaoPagamento: { value: situacoesPagamentos[0].value, label: situacoesPagamentos[0].label }, mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_DIARIAS]: removeAdministracao,
    [Types.REMOVE_NOME_CONSULTA_DIARIAS]: removeNome,
    [Types.REMOVE_CPF_CONSULTA_DIARIAS]: removeCpf,
    [Types.REMOVE_DATA_EMPENHO_INICIAL_CONSULTA_DIARIAS]: removeDataEmpenhoInicial,
    [Types.REMOVE_DATA_EMPENHO_FINAL_CONSULTA_DIARIAS]: removeDataEmpenhoFinal,
    [Types.REMOVE_CARGO_CONSULTA_DIARIAS]: removeCargo,
    [Types.REMOVE_SITUACAO_PAGAMENTO_CONSULTA_DIARIAS]: removeSituacaoPagamento,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_DIARIAS]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_DIARIAS]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_DIARIAS]: aplicarFiltro,
})
